import routerOptions0 from "/home/anh/project/outsource/alobacsi/clinic booking/web-user-app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}